import { useNavigate } from 'react-router-dom';
import ManorShell from './ManorShell';

// "Have you played before?" — Yes skips the rules (home.php), No shows them (begin.php).
export default function ManorMain() {
  const navigate = useNavigate();
  return (
    <ManorShell bg="main/bg.png" bgMob="img/main/bg_mob.jpg">
      <img className="manor-drop manor-title" style={{ top: 0 }} src="/manor/img/main/Title.png" alt="The Haunting of Hollow Manor" />
      <div className="manor-yesno">
        <button type="button" className="manor-img-btn" onClick={() => navigate('/manor/home')}>
          <img src="/manor/img/main/Yes.png" alt="Yes" />
        </button>
        <button type="button" className="manor-img-btn" onClick={() => navigate('/manor/begin')}>
          <img src="/manor/img/main/No.png" alt="No" />
        </button>
      </div>
    </ManorShell>
  );
}
